import type { ReactNode } from 'react';

export const symbol_triangle_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M305-347h349q17.13 0 26.06-15 8.94-15-.06-30L506-682q-9.21-14-26.11-14Q463-696 454-682L279-392q-9 15-.06 30 8.93 15 26.06 15Zm53-60 122-201 121 201H358Zm-34 295.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM479.51-140q141.52 0 241-99Q820-338 820-479.51q0-141.52-99.49-241-99.48-99.49-241-99.49Q338-820 239-720.51q-99 99.48-99 241Q140-338 239-239t240.51 99Zm.49-340Z"
		/>
	</svg>
);
